module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "PopUp"
  }, [(_vm.content.text) ? _c('pre', {
    staticClass: "PopUp-header t-small",
    domProps: {
      "innerHTML": _vm._s(_vm.content.text)
    }
  }, [_vm._v("  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "PopUp-content"
  }, [_c('div', {
    staticClass: "PopUp-overlays"
  }, [_c('transition-group', {
    attrs: {
      "name": "PopUp-overlay-"
    }
  }, _vm._l((_vm.content.options), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeIndex === index),
        expression: "activeIndex === index"
      }],
      key: "index",
      ref: "overlays",
      refInFor: true,
      staticClass: "PopUp-overlay",
      class: ("PopUp-overlay--" + (item.popup))
    }, [(item.title1 || item.description1) ? _c('div', {
      staticClass: "PopUp-overlayItem"
    }, [(item.title1) ? _c('div', {
      staticClass: "PopUp-overlayItemHeader t-headingXs",
      domProps: {
        "innerHTML": _vm._s(item.title1)
      }
    }) : _vm._e(), _vm._v(" "), (item.description1) ? _c('pre', {
      staticClass: "PopUp-overlayItemBody t-capsSm",
      domProps: {
        "innerHTML": _vm._s(item.description1)
      }
    }, [_vm._v("            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.title2 || item.description2) ? _c('div', {
      staticClass: "PopUp-overlayItem"
    }, [(item.title2) ? _c('div', {
      staticClass: "PopUp-overlayItemHeader t-headingXs",
      domProps: {
        "innerHTML": _vm._s(item.title2)
      }
    }) : _vm._e(), _vm._v(" "), (item.description2) ? _c('pre', {
      staticClass: "PopUp-overlayItemBody t-capsSm",
      domProps: {
        "innerHTML": _vm._s(item.description2)
      }
    }, [_vm._v("            ")]) : _vm._e()]) : _vm._e()])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "PopUp-buttons"
  }, _vm._l((_vm.content.options), function(item, index) {
    return _c('div', {
      ref: "buttons",
      refInFor: true,
      staticClass: "PopUp-button",
      style: (_vm.buttonStyle(item)),
      on: {
        "click": function($event) {
          _vm.activate(index)
        }
      }
    }, [_c('expander', {
      attrs: {
        "active": _vm.activeIndex === index
      }
    })], 1)
  })), _vm._v(" "), _c('svg', {
    ref: "lines",
    staticClass: "PopUp-lines",
    attrs: {
      "width": "652",
      "height": "371"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "PopUp-image",
    attrs: {
      "src": _vm.content.image
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2aa8e52"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Learn/PopUp.vue
// module id = 807
// module chunks = 1